<template>
  <div>
    <b-dropdown
      v-model="selectedStatus"
      no-caret
      variant="outline-primary"
      size="sm"
      :class="dropdownClass"
      :toggle-class="toggleClass"
      :disabled="loading || disabled"
    >
      <template #button-content>
        <b-overlay
          :show="loading"
          class="w-auto"
          spinner-variant="primary"
          spinner-small
          variant="light"
          opacity=".8"
          rounded="full"
        >
          <span class="flex items-center justify-between gap-[4px] !py-[5px] !px-[12px]">
            {{ displayText }}
            <span class="k-arrow-down-1 text-[#333333] font-bold" />
          </span>
        </b-overlay>
      </template>
      <b-dropdown-item
        v-for="status in constant.options"
        :key="status.value"
        :disabled="selectedStatus === status.value"
        :class="selectedStatus === status.value ? 'opacity-70 cursor-not-allowed' : ''"
        @click="$emit('need-updated', { value: status.value, oldValue: selectedStatus })"
      >
        <span>{{ status.text }}</span>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import {
  CREATOR_CAMPAIGN_STATUS,
  CREATOR_CAMPAIGN_STATUS_OPTIONS,
} from '../config'

export default {
  name: 'StatusCell',
  props: {
    data: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      selectedStatus: this.data.status ?? null,
    }
  },
  computed: {
    constant() {
      return {
        status: CREATOR_CAMPAIGN_STATUS,
        options: CREATOR_CAMPAIGN_STATUS_OPTIONS,
      }
    },
    displayText() {
      return this.constant.status[this.selectedStatus]?.text ?? 'Pilih Status'
    },
    toggleClass() {
      const { style } = this.constant.status[this.selectedStatus] || ({
        style: {
          mainColor: '#333333',
          subColor: '',
        },
      })
      const computedClass = `!bg-[${style.subColor}] !text-[${style.mainColor}]`
      return `!rounded-full !p-0 ${computedClass}`
    },
    dropdownClass() {
      return `[&_.btn-outline-primary]:!border-[${this.constant.status[this.selectedStatus]?.style.mainColor ?? '#F95031'}] w-[130px]`
    },
  },
  watch: {
    'data.status': {
      handler(newStatus) {
        this.selectedStatus = newStatus ?? null
      },
    },
  },
  methods: {
    setLoading(state) {
      this.loading = state
    },
    setValue(value) {
      this.selectedStatus = value
    },
  },
}
</script>
